var path = 'src/app/users/user-detail.html';
var html = "<div page-wrapper> <h1 class=page-header>{{user.username}}</h1> <div user-component user=user></div> <h2>Groups</h2> <div user-groups-component user=user></div> <p ng-if=currentUser.isAdmin><a ui-sref=\"deleteUser({userId: user.id})\" class=delete-user>Delete User</a></p> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/users/user-detail.html
// module id = 688
// module chunks = 0